module.exports = __webpack_public_path__ + "public/images/history.ea65f08d2bcda4f7ebbc8554ed40ba48.png";